import { render } from "./TanaoroshiWarehouseTransferPage.vue?vue&type=template&id=5fac0788&scoped=true"
import script from "./TanaoroshiWarehouseTransferPage.vue?vue&type=script&lang=js"
export * from "./TanaoroshiWarehouseTransferPage.vue?vue&type=script&lang=js"

import "./TanaoroshiWarehouseTransferPage.vue?vue&type=style&index=0&id=5fac0788&lang=scss&scoped=true"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fac0788"]])

export default __exports__